import { ReactNode } from 'react';
import TopNavBar from './TopNavBar';
import PageTransition from './PageTransition';
import NotificationToast from './NotificationToast';
import Toast from './Toast';
import ErrorBoundary from './ErrorBoundary';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="app-layout">
      {/* Toast overlays */}
      <NotificationToast />
      <Toast />

      {/* Skip-to-main for a11y */}
      <a href="#main-content" className="visually-hidden-focusable">Skip to content</a>

      {/* Fixed Top Navigation */}
      <TopNavBar />

      {/* Scrollable Main Content with iOS-style transitions */}
      <main id="main-content" className="app-content">
        <ErrorBoundary>
          <PageTransition>
            {children}
          </PageTransition>
        </ErrorBoundary>
      </main>
    </div>
  );
}
